export default __webpack_public_path__ + "static/bubbles-9a5d087337c69c373be0287f0bde612d.png";